import type { ChangeEvent, FC } from "react"
import React from "react"

import PhoneInput from "./react-phone-input-2"
import { Tooltip } from "./Tooltip"
import type { IDefaultInputProps } from "./types"
import { defaultTextInputStyles } from "../styles/textInput"
import { Wrapper } from "../utils"

export const TextInput: FC<IDefaultInputProps> = ({
  label,
  id,
  error,
  type,
  onChange,
  name,
  value,
  disabled = false,
  pattern,
  placeholder,
  scrollId,
  tooltip,
  min,
  max,
  step,
  showIcon = true,
  css = defaultTextInputStyles,
}) => {
  return (
    <Wrapper css={css}>
      {label && (
        <label data-testid="text-input-label" data-valid={!error} htmlFor={id}>
          {label}
        </label>
      )}
      <div data-valid={!error} data-role="validation">
        {type === `tel` ? (
          <PhoneInput
            countryCodeEditable={false}
            country={`us`}
            // Forwarded like every other input's: a caller that says disabled
            // means it, and the public GoodLeap form locks the homeowner's
            // number because the server derives it from the Proposal.
            disabled={disabled}
            value={value ?? null}
            specialLabel=""
            onChange={(phone) => {
              onChange?.({
                target: {
                  value: phone ? `${phone}` : ``,
                  id,
                  name: name ?? ``,
                  type,
                },
              } as ChangeEvent<HTMLInputElement>)
            }}
          />
        ) : (
          <input
            data-valid={!error}
            type={type ?? `text`}
            value={value}
            onChange={onChange}
            disabled={disabled}
            data-testid="text-input"
            id={id}
            name={name ?? id}
            min={min}
            placeholder={placeholder}
            pattern={pattern}
            max={max}
            step={step}
          />
        )}
        <Tooltip
          scrollId={scrollId}
          inputId={id}
          isError={!!error}
          message={error ?? tooltip}
          showIcon={showIcon}
        />
      </div>
    </Wrapper>
  )
}
